import CodeHighlighter from './api_sandbox/CodeHighlighter'
import CopyButton      from './api_sandbox/CopyButton'
import Selector        from './api_sandbox/Selector'
import Textarea        from './api_sandbox/Textarea'

export default class ApiSandbox extends React.PureComponent
  NO_SOURCE_CODE = " " # Single space (because empty string messes select height)

  constructor: (props) ->
    super(props)

    @state =
      source:               @props.example.source
      targetCode:           @props.example.targetCode
      sourceCode:           NO_SOURCE_CODE
      engine:               @props.defaultEngine
      tone:                 @props.defaultTone
      context:              ""
      format:               @props.defaultFormat
      target:               @props.example.target
      responseSourceCode:   @props.example.responseSourceCode
      defaultParamsVisible: false
      loading:              false

    @dTranslate = _.debounce(@translate, 300)

    @toggleDefaultParams = @toggleDefaultParams.bind(this)
    @copyJsonRequest     = @copyJsonRequest.bind(this)
    @copyCurlRequest     = @copyCurlRequest.bind(this)
    @updateSource        = @updateSource.bind(this)
    @updateTargetCode    = @updateTargetCode.bind(this)
    @updateSourceCode    = @updateSourceCode.bind(this)
    @updateEngine        = @updateEngine.bind(this)
    @updateTone          = @updateTone.bind(this)
    @updateContext       = @updateContext.bind(this)
    @updateFormat        = @updateFormat.bind(this)

  ## Commented because we provide a default translation in the state
  # componentDidMount: ->
  #   @translate()

  toggleDefaultParams: (e) ->
    @setState(defaultParamsVisible: !@state.defaultParamsVisible)

  copyJsonRequest: (e) ->
    jsonPayload = @buildJsonPayload()
    jsonRequest = JSON.stringify(jsonPayload, null, "  ") # 2-space indentation

    navigator.clipboard.writeText(jsonRequest)

  copyCurlRequest: (e) ->
    jsonPayload = @buildJsonPayload()
    curlData    = JSON.stringify(jsonPayload)        # No indentation required
    curlData    = curlData.replace(/'/g, "\'\\\'\'") # Escape single quotes (') with '\'' (see https://stackoverflow.com/a/39802572)

    curlRequest = """
      curl -X POST https://neurooo.com/api/v1/translate \\
        -H 'Content-Type: application/json' \\
        -H 'x-api-key: YOUR_API_KEY' \\
        -d '#{curlData}'
    """

    navigator.clipboard.writeText(curlRequest)

  buildJsonPayload: ->
    request =
      source:             @state.source
      targetLanguageCode: @state.targetCode
      engine:             @state.engine

    # Add optional parameters if not default or blank
    request.sourceLanguageCode = @state.sourceCode if @state.sourceCode != NO_SOURCE_CODE
    request.tone               = @state.tone       if @state.tone != @props.defaultTone
    request.context            = @state.context    if @state.context.trim() != ''
    request.format             = @state.format     if @state.format != @props.defaultFormat

    humps.decamelizeKeys(request)

  updateSource: (e) ->
    source = e.target.value
    source = source.slice(0, @props.maxSourceSize) if source.length > @props.maxSourceSize

    @updateAndTranslate(source: source)

  updateTargetCode: (e) ->
    @updateAndTranslate(targetCode: e.target.value)

  updateSourceCode: (e) ->
    @updateAndTranslate(sourceCode: e.target.value)

  updateEngine: (e) ->
    @updateAndTranslate(engine: e.target.value)

  updateTone: (e) ->
    @updateAndTranslate(tone: e.target.value)

  updateContext: (e) ->
    context = e.target.value
    context = context.slice(0, @props.maxContentSize) if context.length > @props.maxContentSize
    @updateAndTranslate(context: context)

  updateFormat: (e) ->
    @updateAndTranslate(format: e.target.value)

  updateAndTranslate: (hash) ->
    @setState(hash, @dTranslate)

  translate: ->
    @setState(
      target:             ''
      responseSourceCode: ''
    )

    if @state.source.trim().length
      @setState(loading: true)

      params =
        jsonPayload: JSON.stringify(@buildJsonPayload())

      http.post('/api_sandbox/translate.json', params, (data) =>
        @setState(
          loading:            false
          target:             data.target             || '' # basic fallback in case of errors
          responseSourceCode: data.sourceLanguageCode || '' # basic fallback in case of errors
        )
      )

  render: ->
    classes =  "api-sandbox"
    classes += " response-loading" if @state.loading

    <div className={classes}>
      <div className="code-wrapper request-code">
        <span className="codename">
          {@props.i18n.apiRequestTitle}
        </span>
        { @renderRequestCode() }
      </div>

      <div className="code-wrapper response-code">
        <span className="codename">
          {@props.i18n.apiResponseTitle}
        </span>
        { @renderResponseCode() }
      </div>
    </div>

  renderRequestCode: ->
    <CodeHighlighter>
      { @renderCopyButtons() }
      <span className="p">&#123;</span>
      <ul>
        { @renderSourceParamLi()         }
        { @renderTargetLanguageParamLi() }
        { @renderSourceLanguageParamLi() }
        { @renderEngineParamLi()         }
        { @renderToneParamLi()           }
        { @renderContextParamLi()        }
        { @renderFormatParamLi()         }
      </ul>
      { @renderParamsToggler() }
      <span className="p">&#125;</span>
    </CodeHighlighter>

  renderResponseCode: ->
    if @state.loading
      target             = "..."
      responseSourceCode = "..."
    else
      target             = @state.target.replace(/"/g, '\\"')
      responseSourceCode = @state.responseSourceCode

    <CodeHighlighter>
      <span className="p">&#123;</span>
      <ul>
        <li key="response-target">
          { @renderParamLabel('target', false) }
          &quot;{target}&quot;,
        </li>

        <li key="response-source-language-code">
          { @renderParamLabel('source_language_code', false) }
          &quot;{responseSourceCode}&quot;
        </li>
      </ul>

      <span className="p">&#125;</span>
    </CodeHighlighter>

  renderSourceParamLi: ->
    <li key="source">
      { @renderParamLabel('source') }
      <Textarea id='param-source'
                value={@state.source}
                placeholder={@props.i18n.sourcePlaceholder}
                onChange={@updateSource} />
    </li>

  renderTargetLanguageParamLi: ->
    <li key="target_language_code">
      { @renderParamLabel('target_language_code') }
      <Selector id="param-target_language_code"
                value={@state.targetCode}
                options={@props.languages}
                optionFormatter={(option) -> "#{option[0]} · #{option[1]}" }
                onChange={@updateTargetCode} />
    </li>

  renderSourceLanguageParamLi: ->
    if @state.sourceCode != NO_SOURCE_CODE || @state.defaultParamsVisible
      options = [[NO_SOURCE_CODE, @props.i18n.detectLanguage], ...@props.languages]

      <li key="source_language_code">
        { @renderParamLabel('source_language_code') }
        <Selector id="param-source_language_code"
                  value={@state.sourceCode}
                  options={options}
                  optionFormatter={(option) -> "#{option[0]} · #{option[1]}" }
                  onChange={@updateSourceCode} />
      </li>

  renderEngineParamLi: ->
    <li key="engine">
      { @renderParamLabel('engine') }
      <Selector id="param-engine"
                value={@state.engine}
                options={@props.engines.map((engine) -> [engine, engine])}
                onChange={@updateEngine} />
    </li>

  renderToneParamLi: ->
    if @state.tone != @props.defaultTone || @state.defaultParamsVisible
      <li key="tone">
        { @renderParamLabel('tone') }
        <Selector id="param-tone"
                  value={@state.tone}
                  options={@props.tones.map((tone) -> [tone, tone])}
                  onChange={@updateTone} />
      </li>

  renderContextParamLi: ->
    if @state.context.trim() != '' || @state.defaultParamsVisible
      <li key="context">
        { @renderParamLabel('context') }
        <Textarea id="param-context"
                  value={@state.context}
                  placeholder={@props.i18n.contextPlaceholder}
                  onChange={@updateContext} />
      </li>

  renderFormatParamLi: ->
    if @state.format != 'auto' || @state.defaultParamsVisible
      <li key="format">
        { @renderParamLabel('format') }
        <Selector id="param-format"
                  value={@state.format}
                  options={@props.formats.map((format) -> [format, format])}
                  onChange={@updateFormat} />
      </li>

  renderParamLabel: (name, withForAttribute = true) ->
    htmlFor = if withForAttribute then "param-#{name}" else ""

    <label htmlFor={htmlFor}>
      &quot;{name}&quot;
      <span>:</span>
    </label>

  renderParamsToggler: ->
    if @state.defaultParamsVisible
      icon  = 'fa-eye-slash'
      label = @props.i18n.hideParameters
    else
      icon  = 'fa-eye'
      label = @props.i18n.showParameters

    <button className="params-toggler"
            onClick={@toggleDefaultParams}>
      <i className="fas #{icon} me-2"></i>
      {label}
    </button>

  renderCopyButtons: ->
    <div className="copy-buttons-wrapper">
      <CopyButton initialText={@props.i18n.copyJson}
                  successText={@props.i18n.jsonCopied}
                  onClick={@copyJsonRequest} />
      <CopyButton initialText={@props.i18n.copyCurl}
                  successText={@props.i18n.curlCopied}
                  onClick={@copyCurlRequest} />
    </div>
